import * as Sentry from '@sentry/react';
import { browserTracingIntegration } from '@sentry/react';

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export function initSentry() {
  if (!SENTRY_DSN) {
    return;
  }

  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_SENTRY_ENV || 'production',
    release: process.env.REACT_APP_SENTRY_RELEASE || process.env.npm_package_version,
  });
}

export default Sentry;
